import React, { Suspense } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import candidateRoutes from '../../../routes/candidate';
import clientRoutes from '../../../routes/client';
import sharedRoutes from 'routes/shared';
import AuthorizedRoute from '../AuthorizedRoute';
import CandidateSidebar from '../../Sidebar/candidateSidebar';
import ClientSidebar from '../../Sidebar/clientSidebar';
import Sidebar from '../../Sidebar';
import { isAuthenticated, decodeToken, getToken } from '../../../utils/auth';

/**
 * Renders the component if the user is authenticated
 *
 * @param {Component} Component
 *
 * @returns {JSX}
 */
const renderComponent = (Component) => (props) => {
  return <Component {...props} />;
};

/**
 * This Component returns a new
 * route based on authenticated status
 *
 * @returns {JSX}
 */
const AuthenticatedRoute = (props) => {
  const { component: Component, path, ...rest } = props;
  const checkisAuthenticated = isAuthenticated();
  const token = getToken();
  const user = decodeToken(token);
  const location = useLocation();
  const { pathname } = location;


  const isCandidate = ['EMPLOYEE'].some((val) => user?.roles?.includes(val));
  const isClient = ['CLIENT'].some((val) => user?.roles?.includes(val));
  const isAdmin = ['ADMIN', 'SUPERADMIN'].some((val) => user?.roles?.includes(val));

  if (!checkisAuthenticated) {
    // return window.location.href = `${process.env.REACT_APP_EMPLOYEE_REDIRECT_URL}?pathto=${pathname}}`;
    return <Redirect to={`/signin?pathto=${pathname}`} />;
  }

  if (isCandidate) {
    const candidateAllowedRef = [...candidateRoutes, ...sharedRoutes].map(
      (each) => each.path
    );
    if (!candidateAllowedRef?.includes(path)) {
      return <Redirect to="/404" />;
    }
  }

  if (isClient) {
    const clientallowedRef = [...clientRoutes, ...sharedRoutes].map((each) => each.path);

    if (!clientallowedRef?.includes(path)) {
      return <Redirect to="/404" />;
    }
  }



  return (
    <>
      {isCandidate && (
        <CandidateSidebar candidate={isCandidate}>
          <Suspense fallback={<div>Loading...</div>}>
            <AuthorizedRoute {...rest} path={path} render={renderComponent(Component)} />
          </Suspense>
        </CandidateSidebar>
      )}
      {isAdmin && (
        <Sidebar candidate={false}>
          <Suspense fallback={<div></div>}>
            <AuthorizedRoute {...rest} path={path} render={renderComponent(Component)} />
          </Suspense>
        </Sidebar>
      )}

      {isClient && (
        <ClientSidebar client={isClient} candidate={false}>
          <Suspense fallback={<div></div>}>
            <AuthorizedRoute {...rest} path={path} render={renderComponent(Component)} />
          </Suspense>
        </ClientSidebar>
      )}
    </>
  );
};

export default AuthenticatedRoute;
